import { render } from "./PageMyBots.vue?vue&type=template&id=0c19fd02&scoped=true"
import script from "./PageMyBots.vue?vue&type=script&lang=js"
export * from "./PageMyBots.vue?vue&type=script&lang=js"

import "./PageMyBots.vue?vue&type=style&index=0&id=0c19fd02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c19fd02"]])

export default __exports__